/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { UserStorage } from '../model';
// @ts-ignore
import { UserStorageKey } from '../model';
/**
 * UserStorageApi - axios parameter creator
 * @export
 */
export const UserStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the stored value for the specified key from user storage
         * @summary Delete user storage value
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserStorage: async (key: UserStorageKey, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteUserStorage', 'key', key)
            const localVarPath = `/userStorage/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the stored value for the specified key from user storage
         * @summary Get user storage value by key
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStorageByKey: async (key: UserStorageKey, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getUserStorageByKey', 'key', key)
            const localVarPath = `/userStorage/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates or creates a user storage value for the specified key
         * @summary Update user storage value
         * @param {UserStorage} userStorage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStorage: async (userStorage: UserStorage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userStorage' is not null or undefined
            assertParamExists('updateUserStorage', 'userStorage', userStorage)
            const localVarPath = `/userStorage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userStorage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserStorageApi - functional programming interface
 * @export
 */
export const UserStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the stored value for the specified key from user storage
         * @summary Delete user storage value
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserStorage(key: UserStorageKey, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserStorage(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the stored value for the specified key from user storage
         * @summary Get user storage value by key
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserStorageByKey(key: UserStorageKey, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserStorage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserStorageByKey(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates or creates a user storage value for the specified key
         * @summary Update user storage value
         * @param {UserStorage} userStorage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserStorage(userStorage: UserStorage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserStorage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserStorage(userStorage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserStorageApi - factory interface
 * @export
 */
export const UserStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserStorageApiFp(configuration)
    return {
        /**
         * Deletes the stored value for the specified key from user storage
         * @summary Delete user storage value
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserStorage(key: UserStorageKey, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserStorage(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the stored value for the specified key from user storage
         * @summary Get user storage value by key
         * @param {UserStorageKey} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStorageByKey(key: UserStorageKey, options?: any): AxiosPromise<UserStorage> {
            return localVarFp.getUserStorageByKey(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates or creates a user storage value for the specified key
         * @summary Update user storage value
         * @param {UserStorage} userStorage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStorage(userStorage: UserStorage, options?: any): AxiosPromise<UserStorage> {
            return localVarFp.updateUserStorage(userStorage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserStorageApi - object-oriented interface
 * @export
 * @class UserStorageApi
 * @extends {BaseAPI}
 */
export class UserStorageApi extends BaseAPI {
    /**
     * Deletes the stored value for the specified key from user storage
     * @summary Delete user storage value
     * @param {UserStorageKey} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStorageApi
     */
    public deleteUserStorage(key: UserStorageKey, options?: any) {
        return UserStorageApiFp(this.configuration).deleteUserStorage(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the stored value for the specified key from user storage
     * @summary Get user storage value by key
     * @param {UserStorageKey} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStorageApi
     */
    public getUserStorageByKey(key: UserStorageKey, options?: any) {
        return UserStorageApiFp(this.configuration).getUserStorageByKey(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates or creates a user storage value for the specified key
     * @summary Update user storage value
     * @param {UserStorage} userStorage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserStorageApi
     */
    public updateUserStorage(userStorage: UserStorage, options?: any) {
        return UserStorageApiFp(this.configuration).updateUserStorage(userStorage, options).then((request) => request(this.axios, this.basePath));
    }
}
